import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Sarlaft } from '../../../../../shared/types/modules/sarlaft';
import { ACCOUNTS } from '../../../../../routes/paths';
import { asyncGetSarlaft } from '../../../../../services/sarlaft.service';

export const useSarlaftDetail = () => {
    const navigate = useNavigate();
    const { idSarlaft } = useParams();
    const [loading, setLoading] = useState(false);
    const [sarlaft, setSarlaft] = useState<Sarlaft>();

    useEffect(() => {
        if (Boolean(idSarlaft?.trim())) {
            setLoading(true);
            asyncGetSarlaft(idSarlaft?.trim())
                .then((sarlaft) => {
                    if (sarlaft) setSarlaft(sarlaft);
                    else navigate(ACCOUNTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idSarlaft]);

    return { loading, sarlaft };
};
